import { GetSubscriptionsResponseBodyType } from "@intelligems/ig-types";
import { useQuery } from "@tanstack/react-query";

import { QueryMeta, QueryOptions } from "../../types/react-query";
import { api } from "../api";
import { subscriptionsKeys } from "../queryKeys";

const getSubscriptions = async (all?: boolean) => {
  const resp = await api.get<GetSubscriptionsResponseBodyType>(
    `/v2/intelligems/subscriptions`,
    {
      params: { all },
    }
  );
  return resp.data;
};

export const useSubscriptions = (options?: {
  orgId: string;
  all?: boolean;
  queryOptions?: QueryOptions<GetSubscriptionsResponseBodyType, Error>;
}) => {
  return useQuery<GetSubscriptionsResponseBodyType, Error>({
    ...options?.queryOptions,
    queryKey: subscriptionsKeys.all(options?.all || false),
    queryFn: async () => getSubscriptions(options?.all),
    enabled: !!options?.orgId,
    meta: {
      onError: {
        401: "ignore",
      },
    } as QueryMeta,
  });
};
